/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swift_Dull_Clownfish_QuizInputs */

const fr_swift_dull_clownfish_quiz = /** @type {(inputs: Swift_Dull_Clownfish_QuizInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message`)
};

/**

* @param {Swift_Dull_Clownfish_QuizInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const swift_dull_clownfish_quiz = /** @type {((inputs?: Swift_Dull_Clownfish_QuizInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swift_Dull_Clownfish_QuizInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_swift_dull_clownfish_quiz(inputs)
});